import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ItemStatusModel from '../../../models/ItemStatusModel';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';

const ItemStatusType_tab_ItemStatuses: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<ItemStatusModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<ItemStatusModel[]>('api/v1/ItemStatuses/ByItemStatusType/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ItemStatuses/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }


    function getCellColor(itemStatus: ItemStatusModel, colInfo: IColInfo): string | undefined {
        return itemStatus.color;
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Kleur', getCellBackgroundColor: getCellColor, sort: false, width: 50 },
        { title: 'Name', dataProp: 'name', sort: 'asc' },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date', width: 120, align: 'right' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date', width: 120, align: 'right' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditItemStatusType)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemStatusTypeItemStatuses'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Item status'
                navigateUrl='/plm/ItemSetup/ItemStatus/'
            />
        </>
    );
}
export default ItemStatusType_tab_ItemStatuses;